import { strategyToOptions } from '@/common/utils/strategyToOptions'

export const auctionEntryKind: Record<string, string> = {
  open: 'Aberto',
  closed: 'Fechado',
}

export const auctionEntryKindOptions = strategyToOptions(auctionEntryKind)
